const lotIdRegex = /^.+-(?<c>\d+)\/.*$/

export function extractObjectIdFromPath(path: string): string {
  if (!path.endsWith('/')) {
    path += '/'
  }

  const shortResult = lotIdRegex.exec(path)
  if (shortResult && shortResult.groups != null) {
    return shortResult.groups['c']
  }

  return ''
}

//  DON'T DELETE - used by DW
